<script lang="ts">
  import { FREE_INDEX } from '@banger/shared';

  let { cells, size = '9rem', label = '', platinum = false }: {
    /** Highlighted cell indexes (row-major 0-24). */
    cells: readonly number[];
    /** Width of the whole grid (any CSS length). */
    size?: string;
    /** Accessible name, e.g. the pattern's label. */
    label?: string;
    /** Silver lit squares (Track 3) instead of neon pink. */
    platinum?: boolean;
  } = $props();

  const lit = $derived(new Set(cells));
</script>

<div class="grid" class:platinum style="--size:{size}" role="img" aria-label={label ? `Pattern: ${label}` : 'Pattern'}>
  {#each Array(25) as _, i}
    <span class:on={lit.has(i)} class:free={i === FREE_INDEX}>{i === FREE_INDEX ? '★' : ''}</span>
  {/each}
</div>

<style>
  .grid {
    /* Sizes derive from --size: a % padding would resolve against the parent's width. */
    width: var(--size); height: var(--size); display: grid; grid-template: repeat(5, 1fr) / repeat(5, 1fr);
    gap: calc(var(--size) * 0.035); padding: calc(var(--size) * 0.06); border-radius: calc(var(--size) * 0.1); background: rgba(10, 6, 24, 0.6);
    box-shadow: 0 0 0 2px rgba(125, 249, 255, 0.45), 0 0 24px rgba(125, 249, 255, 0.25);
  }
  span {
    border-radius: 18%; background: rgba(255, 255, 255, 0.08); display: flex; align-items: center; justify-content: center;
    font-size: calc(var(--size) / 9); line-height: 1; color: rgba(255, 255, 255, 0.4);
    transition: background 0.25s, box-shadow 0.25s;
  }
  .on { background: var(--pink); box-shadow: 0 0 10px var(--pink); color: #fff; }
  .platinum .on { background: linear-gradient(180deg, #ffffff, #b8c4d6); box-shadow: 0 0 10px rgba(255, 255, 255, 0.8); color: #2b2f45; }
</style>
